<template>
  <div class="lives-enterinfolist">
    <Row>
      <Col>
        <Button @click="showModel()" type="success">添加</Button>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus" :title="title" @on-ok="createOrUpdate()" :loading="loading">
      <Form :model="dataInfo" action="javascript:void(0)">
        <FormItem label="场馆名称">
          <Input v-model="dataInfo.venue_name" placeholder="请输入场馆名称..."></Input>
        </FormItem>
        <FormItem label="产品名称">
          <Input v-model="dataInfo.product_name" placeholder="请输入产品名称..."></Input>
        </FormItem>
        <FormItem label="活动名称">
          <Input v-model="dataInfo.activity_name" placeholder="请输入活动名称..."></Input>
        </FormItem>
        <FormItem label="金额">
          <Input v-model="dataInfo.money" placeholder="请输入金额..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "lives-enterinfolist",
  data() {
    return {
      loading: true,
      dataloading: true,
      thumblist: [],
      venueList: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "场馆名称",
          key: "venue_name",
          width: 150
        },
        {
          title: "产品名称",
          key: "product_name",
          width: 150
        },
        {
          title: "活动名称",
          key: "activity_name",
          width: 150
        },
        {
          title: "金额",
          key: "money",
          width: 100
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      dataInfo: {
        venue_name: "",
        product_name: "",
        activity_name: "",
        money: 0
      },
      showModalStatus: false
    };
  },
  // 组件
  components: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.venueproduct
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 展开添加
    showModel() {
      this.title = "添加";
      this.dataInfo = {
        venue_name: "",
        product_name: "",
        activity_name: "",
        money: 0
      };
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail(index, id) {
      this.title = "编辑";
      this.dataInfo = {
        venue_name: "",
        product_name: "",
        activity_name: "",
        money: 0
      };
      this.showModalStatus = !this.showModalStatus;
      this.$api.venueproduct.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
      });
    },
    // 添加
    createOrUpdate(name) {
      if (this.dataInfo.id == null || this.dataInfo.id == 0) {
        this.$api.venueproduct.create(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showModalStatus = !this.showModalStatus;
        });
      } else {
        this.$api.venueproduct.edit(this.dataInfo).then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
          this.showModalStatus = !this.showModalStatus;
        });
      }
    },
    // 删除
    remove: function(index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.venueproduct.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.renderTable(1);
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function(index, value) {
      var status = value == true ? 1 : 0;
      this.$api.venueproduct.status({ id: index, status: status }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.venueproduct.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>

<style scoped>
</style>
